import { IUser } from 'app/shared/model/user.model';
import { IImportantUserDetails } from './important-user-details.model';

export interface ITransactionDetails {
  id?: number;
  paymentTransactionId?: string;
  product?: string;
  productName?: string;
  productId?: number;
  amount?: number;
  user?: IUser;
  createdBy?: string;
  createdDate?: Date | null;
  lastModifiedBy?: string;
  lastModifiedDate?: Date | null;
  importantUserDetails?: IImportantUserDetails | null;
}

export const defaultValue: Readonly<ITransactionDetails> = {};
